import React from 'react';
import { cn } from '@magicbrief/ui/src/lib/cn';
import { NavLink } from 'react-router-dom';
import { Button } from 'react-aria-components';
import { ChevronDown } from '@magicbrief/ui/src/icons/chevron-down';
import { AriaMenu } from 'src/components/AriaMenu/AriaMenu';
import { Icon } from 'src/components/Icon';

type ToolbarTitleProps = {
  title: string | React.ReactNode;
  subtitle?: string;
  link: string | null;
  icon?: React.ReactNode;
  className?: string;
};

const defaultClassName =
  'flex appearance-none flex-row items-center gap-3 text-base font-semibold [&_svg]:shrink-0 min-w-0 text-primary py-2';

export const ToolbarTitle: React.FC<ToolbarTitleProps> = ({
  className,
  link,
  icon,
  title,
  subtitle,
}) => {
  return (
    <span className={cn(defaultClassName, className)}>
      {icon}
      <span className={`truncate ${subtitle ? 'opacity-50' : ''}`}>
        {link ? (
          <NavLink
            end
            to={link}
            className={({ isActive }) => (isActive ? '' : 'opacity-50')}
          >
            {title}
          </NavLink>
        ) : (
          title
        )}
      </span>
      {subtitle && (
        <>
          <span className="opacity-50">/</span>
          <span className="truncate">{subtitle}</span>
        </>
      )}
    </span>
  );
};

type ToolbarTitleNavigationMenuProps = {
  title: string | React.ReactNode;
  subtitle?: string;
  icon?: React.ReactNode;
  className?: string;
};

export const ToolbarTitleNavigationMenu: React.FC<
  React.PropsWithChildren<ToolbarTitleNavigationMenuProps>
> = ({ className, children, icon, title, subtitle }) => {
  return (
    <span className={cn(defaultClassName, className)}>
      <AriaMenu>
        <Button className="flex appearance-none flex-row items-center gap-3">
          {icon}
          <span className={`truncate ${subtitle ? 'opacity-50' : ''}`}>
            {title}
          </span>
          <Icon>
            <ChevronDown />
          </Icon>
        </Button>
        {children}
      </AriaMenu>
      {subtitle && (
        <>
          <span className="opacity-50">/</span>
          <span className="truncate">{subtitle}</span>
        </>
      )}
    </span>
  );
};
